/* CLIKEA GAMING product page: gallery, variant pills, quantity, sticky bar, tabs and dialogs. */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-clp]').forEach((root) => {
    // ---------- Gallery ----------
    const track = root.querySelector('[data-clp-track]');
    const slides = Array.from(root.querySelectorAll('[data-clp-slide]'));
    const thumbs = Array.from(root.querySelectorAll('[data-clp-thumb]'));
    const indexLabel = root.querySelector('[data-clp-index]');
    let current = 0;

    const goTo = (index, smooth = true) => {
      if (!track || !slides.length) return;
      current = (index + slides.length) % slides.length;
      track.scrollTo({ left: slides[current].offsetLeft - track.offsetLeft, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
      mark();
    };
    const mark = () => {
      if (indexLabel) indexLabel.textContent = String(current + 1);
      thumbs.forEach((thumb, k) => thumb.classList.toggle('is-active', k === current));
      const active = thumbs[current];
      if (active) active.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    };
    if (track) {
      let frame = 0;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const next = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (next !== current && next >= 0 && next < slides.length) {
            current = next;
            mark();
          }
        });
      });
      track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') goTo(current + 1);
        if (event.key === 'ArrowLeft') goTo(current - 1);
      });
    }
    root.querySelector('[data-clp-prev]')?.addEventListener('click', () => goTo(current - 1));
    root.querySelector('[data-clp-next]')?.addEventListener('click', () => goTo(current + 1));
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => goTo(Number(thumb.dataset.clpThumb))));

    // ---------- Lightbox ----------
    const lightbox = root.querySelector('[data-clp-lightbox]');
    const lightboxImg = root.querySelector('[data-clp-lightbox-img]');
    const showInLightbox = (index) => {
      const img = slides[index]?.querySelector('img');
      if (!img || !lightboxImg) return;
      const src = img.currentSrc || img.src;
      lightboxImg.src = src.replace(/width=\d+/, 'width=1800');
      lightboxImg.alt = img.alt;
    };
    slides.forEach((slide, index) =>
      slide.addEventListener('click', () => {
        if (!lightbox?.showModal) return;
        current = index;
        showInLightbox(index);
        lightbox.showModal();
      }),
    );
    lightbox?.querySelector('[data-clp-lb-prev]')?.addEventListener('click', () => {
      current = (current - 1 + slides.length) % slides.length;
      showInLightbox(current);
      goTo(current, false);
    });
    lightbox?.querySelector('[data-clp-lb-next]')?.addEventListener('click', () => {
      current = (current + 1) % slides.length;
      showInLightbox(current);
      goTo(current, false);
    });

    // ---------- Dialogs ----------
    root.querySelectorAll('[data-clp-open]').forEach((button) => {
      const dialog = root.querySelector(`[data-clp-dialog="${button.dataset.clpOpen}"]`);
      button.addEventListener('click', () => dialog?.showModal?.());
    });
    root.querySelectorAll('dialog').forEach((dialog) => {
      dialog.querySelectorAll('[data-clp-close]').forEach((close) => close.addEventListener('click', () => dialog.close()));
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    });

    // ---------- Quantity ----------
    const qtyInput = root.querySelector('.clp-qty input');
    root.querySelectorAll('[data-clp-qty]').forEach((button) =>
      button.addEventListener('click', () => {
        const next = Math.max(1, (Number(qtyInput.value) || 1) + Number(button.dataset.clpQty));
        qtyInput.value = String(next);
      }),
    );

    // ---------- Variants ----------
    const variantsNode = root.querySelector('[data-clp-variants]');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    const groups = Array.from(root.querySelectorAll('[data-clp-option]'));
    const input = root.querySelector('[data-clp-variant-input]');
    const addButton = root.querySelector('[data-clp-add]');
    const stickyButton = root.querySelector('.clp-add--sticky');
    const stickyLabel = root.querySelector('[data-clp-sticky-label]');
    const setText = (selector, text) => {
      const node = root.querySelector(selector);
      if (node && text !== null && text !== undefined) node.textContent = text;
    };
    // ---------- CLIKEA Protect ----------
    const protectBox = root.querySelector('[data-clp-protect]');
    const protectVariants = protectBox ? JSON.parse(protectBox.querySelector('[data-clp-protect-variants]').textContent) : [];
    const money = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 });
    let protectYears = '1 año';
    let protectRange = null;
    const rangeFor = (cents) => {
      const pesos = cents / 100;
      const labels = [...new Set(protectVariants.map((entry) => entry.range))];
      return labels.find((label) => {
        const match = /(\d+)k-(\d+)k/i.exec(label);
        return match && pesos >= Number(match[1]) * 1000 && pesos <= Number(match[2]) * 1000;
      }) || null;
    };
    const protectVariant = (plan) =>
      protectVariants.find((entry) => entry.plan === plan && entry.range === protectRange && entry.years === protectYears && entry.available);
    const refreshProtect = (cents) => {
      if (!protectBox) return;
      protectRange = rangeFor(cents);
      protectBox.hidden = !protectRange;
      protectBox.querySelectorAll('[data-clp-plan-price]').forEach((node) => {
        const variant = protectVariant(node.dataset.clpPlanPrice);
        node.textContent = variant ? `+${money.format(variant.price / 100)}` : 'No disponible';
        const radio = node.closest('label')?.querySelector('input');
        if (radio) radio.disabled = !variant;
      });
    };
    protectBox?.querySelectorAll('[data-clp-years]').forEach((button) =>
      button.addEventListener('click', () => {
        protectYears = button.dataset.clpYears;
        protectBox.querySelectorAll('[data-clp-years]').forEach((other) => other.setAttribute('aria-pressed', String(other === button)));
        refreshProtect(currentCents);
      }),
    );
    const selectedProtect = () => {
      const plan = protectBox && !protectBox.hidden ? protectBox.querySelector('input[type=radio]:checked')?.value : '';
      return plan ? protectVariant(plan) : null;
    };

    const stockBadge = root.querySelector('[data-clp-stock-badge]');
    const stockLine = root.querySelector('[data-clp-stock]');
    let currentCents = variants.find((variant) => String(variant.id) === input?.value)?.cents ?? variants[0]?.cents ?? 0;

    const applyVariant = (variant) => {
      if (!variant) {
        if (addButton) {
          addButton.disabled = true;
          addButton.querySelector('span').textContent = 'No disponible';
        }
        if (stickyButton) stickyButton.disabled = true;
        if (stickyLabel) stickyLabel.textContent = 'No disponible';
        return;
      }
      if (input) input.value = String(variant.id);
      setText('[data-clp-price-now]', variant.priceCurrency);
      setText('[data-clp-sticky-price]', variant.price);
      const hasCompare = Boolean(variant.compare);
      root.querySelector('[data-clp-before]')?.classList.toggle('hidden', !hasCompare);
      root.querySelector('[data-clp-save]')?.classList.toggle('hidden', !hasCompare);
      if (hasCompare) {
        setText('[data-clp-compare]', variant.compare);
        setText('[data-clp-save-amount]', variant.save);
      }
      const offBadge = root.querySelector('[data-clp-off]');
      if (offBadge) {
        offBadge.textContent = `-${variant.off}%`;
        offBadge.hidden = !variant.off;
      }
      const label = variant.available ? 'Agregar al carrito' : 'Agotado';
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.querySelector('span:not(.loading__spinner)').textContent = label;
      }
      if (stickyButton) stickyButton.disabled = !variant.available;
      if (stickyLabel) stickyLabel.textContent = label;
      currentCents = variant.cents;
      refreshProtect(variant.cents);
      const stockText = !variant.available ? 'Agotado' : variant.low ? `Últimas ${variant.low} pzas` : 'En existencia';
      if (stockBadge) {
        stockBadge.textContent = stockText;
        stockBadge.className = `clp-badge ${!variant.available ? 'clp-badge--out' : variant.low ? 'clp-badge--stock' : 'clp-badge--instock'}`;
      }
      if (stockLine) {
        stockLine.textContent = variant.available ? 'En existencia' : 'Agotado';
        stockLine.classList.toggle('is-out', !variant.available);
      }
      if (variant.mediaId) {
        const index = slides.findIndex((slide) => slide.dataset.mediaId === String(variant.mediaId));
        if (index >= 0) goTo(index);
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(variant.id));
      window.history.replaceState({}, '', url.toString());
    };
    groups.forEach((group) => {
      group.querySelectorAll('[data-clp-value]').forEach((pill) =>
        pill.addEventListener('click', () => {
          group.querySelectorAll('[data-clp-value]').forEach((other) => {
            const selected = other === pill;
            other.classList.toggle('is-selected', selected);
            other.setAttribute('aria-pressed', String(selected));
          });
          const chosen = groups.map((g) => g.querySelector('.is-selected')?.dataset.clpValue);
          applyVariant(variants.find((variant) => variant.options.every((value, k) => value === chosen[k])));
        }),
      );
    });

    refreshProtect(currentCents);
    const form = root.querySelector('form.clp-form');
    const meta = JSON.parse(root.querySelector('[data-clp-meta]')?.textContent || '{}');
    const errorWrap = root.querySelector('.product-form__error-message-wrapper');
    const jsonPost = async (url, body) => {
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(result.description || result.message || 'No pude actualizar tu bolsa.');
      return result;
    };
    const readCart = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((res) => res.json());
    // One CLIKEA Protect line per PC, keyed by the "Equipo protegido" property.
    const planLinesFor = (cart) =>
      (cart.items || []).filter((item) => item.properties && item.properties['Equipo protegido'] === meta.title);
    const pcQuantityIn = (cart) =>
      (cart.items || []).filter((item) => item.product_id === meta.productId).reduce((total, item) => total + item.quantity, 0);

    // If this PC already has a plan in the bag, show it selected so a new choice replaces it.
    if (protectBox) {
      readCart()
        .then((cart) => {
          const current = planLinesFor(cart)[0];
          if (!current) return;
          const planName = current.options_with_values?.[0]?.value;
          const years = current.options_with_values?.[2]?.value;
          if (years) protectBox.querySelector(`[data-clp-years="${years}"]`)?.click();
          const radio = [...protectBox.querySelectorAll('input[type=radio]')].find((entry) => entry.value === planName);
          if (radio && !radio.disabled) radio.checked = true;
          const note = protectBox.querySelector('[data-clp-protect-current]');
          if (note) {
            note.hidden = false;
            note.textContent = `Ya tienes CLIKEA Protect ${planName} · ${years} para esta PC en tu bolsa. Si eliges otro plan, lo cambiamos.`;
          }
        })
        .catch(() => undefined);
    }

    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!addButton || addButton.disabled || addButton.classList.contains('loading')) return;
      const quantity = Math.max(1, Number(qtyInput?.value) || 1);
      const plan = selectedProtect();
      addButton.classList.add('loading');
      addButton.querySelector('.loading__spinner')?.classList.remove('hidden');
      if (errorWrap) errorWrap.hidden = true;
      try {
        const cart = await readCart();
        const existing = planLinesFor(cart);
        const pcTotal = pcQuantityIn(cart) + quantity;
        if (plan) {
          // Replace any plan this PC already had instead of adding a second one.
          for (const line of existing) await jsonPost('/cart/change.js', { id: line.key, quantity: 0 });
          await jsonPost('/cart/add.js', {
            items: [
              { id: Number(input.value), quantity },
              { id: plan.id, quantity: pcTotal, properties: { 'Equipo protegido': meta.title || '' } },
            ],
          });
        } else {
          await jsonPost('/cart/add.js', { items: [{ id: Number(input.value), quantity }] });
          // The PC keeps its existing plan, now covering every unit.
          if (existing[0] && existing[0].quantity !== pcTotal) {
            await jsonPost('/cart/change.js', { id: existing[0].key, quantity: pcTotal });
          }
        }
        window.location.href = meta.cartUrl || '/cart';
      } catch (error) {
        if (errorWrap) {
          errorWrap.hidden = false;
          errorWrap.querySelector('.product-form__error-message').textContent = error.message;
        }
        addButton.classList.remove('loading');
        addButton.querySelector('.loading__spinner')?.classList.add('hidden');
      }
    });

    // ---------- Sticky bar (phones) ----------
    const sticky = root.querySelector('[data-clp-sticky]');
    const buyBox = root.querySelector('[data-clp-buy]');
    if (sticky && buyBox && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', String(!show));
          stickyButton?.setAttribute('tabindex', show ? '0' : '-1');
          document.body.classList.toggle('clp-sticky-on', show);
        },
        { threshold: 0 },
      );
      observer.observe(buyBox);
    }

    // ---------- Tabs ----------
    const tabs = Array.from(root.querySelectorAll('[data-clp-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-clp-panel]'));
    tabs.forEach((tab, index) =>
      tab.addEventListener('click', () => {
        tabs.forEach((other, k) => other.setAttribute('aria-selected', String(k === index)));
        panels.forEach((panel, k) => {
          panel.hidden = k !== index;
        });
      }),
    );
  });
})();
